require('./bootstrap');

$(function() {
    activateBootstrapTooltips()
    makeImagesEnlargeable()
    addClipboardFunctionality()
    darkModeToggle()
    changeUrlOnModalOpen($('#modal'))
    registerServiceWorker()
});

function makeImagesEnlargeable() {
    $('body').on('click', '.img-enlargeable', function(e) {
        var img_url = '/storage/photos/'+$(this).attr('data-image-hash')
        $('.image-fullscreen').empty().append($("<img>", {src: img_url})).show()
    })
    $('.image-fullscreen').on('click', function(e) {
        $('.image-fullscreen').empty().hide()
    })
}

function writeClipboard(text) {
    return navigator.clipboard.writeText(text).then(function() {
        return true
    }, function() {
        console.log('Copy to clipboard failed.')
        return false
    });
}

function activateBootstrapTooltips() {
    $('body').tooltip({
        selector: '[data-bs-toggle="tooltip"]'
    });
}

function addClipboardFunctionality() {
    $(document).on('click', '.btn-clipboard-write', function(e) {
        let url = $(this).attr('data-url')
        if(writeClipboard(url)) {
            const tooltip = bootstrap.Tooltip.getInstance(this)
            tooltip.setContent({ '.tooltip-inner': 'Copied' })
        }
    })
}

function darkModeToggle() {
    document.addEventListener('toggleDarkMode', e => {
        let app_stylesheet = document.getElementById('app_stylesheet')
        let url = e.detail.is_dark_mode ? e.detail.app_css_dark_url : e.detail.app_css_url
        app_stylesheet.setAttribute("href", url)
    })
}

function changeUrlOnModalOpen(modal) {
    modal.on('show.bs.modal', function () {
        if (typeof (history.pushState) != "undefined") {
            history.pushState(null, null, $(this).attr('data-url'))

            // Tell Matomo about modal view (disabled in local env)
            if (typeof _paq !== 'undefined') {
                _paq.push(['trackEvent', 'Modal view', window.location.href]);
            }
        }
    })
    modal.on('hide.bs.modal', function () {
        if (typeof (history.pushState) != "undefined") {
            history.pushState(null, null, '/')
        }
    })
}

function registerServiceWorker() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js').then(function (registration) {
            // console.log('ServiceWorker registration successful!');
        }).catch(function (err) {
            console.log('ServiceWorker registration failed: ', err);
        });
    }
}
